
import React from 'react';

const steps = [
  {
    number: '01',
    icon: 'ri-file-list-3-line',
    title: 'Submit Your Referral',
    description:
      "Fill out our simple form with your client’s basic information. It takes less than 2 minutes to get started.",
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'We Review the Case',
    description:
      "Our expert team evaluates the referral and provides instant confirmation. You’ll know the status right away.",
  },
  {
    number: '03',
    icon: 'ri-discuss-line',
    title: 'Resolution Begins',
    description:
      'We work directly with the client to resolve their situation using our proven 20+ year methodology.',
  },
  {
    number: '04',
    icon: 'ri-money-dollar-circle-line',
    title: 'You Get Paid',
    description:
      'Once the case is resolved, you receive your commission. Simple, transparent, and reliable every time.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 text-blue-600 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Simple Process
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
            How It <strong>Works</strong>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto leading-relaxed">
            Our streamlined four-step process makes it easy to turn your bad leads,
            delinquencies, and judgments into real commissions.
          </p>
        </div>

        <div className="relative">
          {/* Decorative line – hidden on small screens */}
          <div className="hidden lg:block absolute top-24 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative inline-block mb-6">
                  <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-blue-700 text-white text-xl font-bold shadow-lg shadow-blue-600/30 mx-auto">
                    {step.number}
                  </div>
                </div>
                <div className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-all">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-blue-50 mx-auto mb-4">
                    <i className={`${step.icon} text-xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
